<template>
  <el-dialog
    :title="title"
    :visible.sync="isColumn"
    width="900px"
    top="17%"
    :before-close="close"
    :centered="true"
  >
    <a-spin :spinning="aTreeShow">
      <div class="org-box">
        <div class="org-left">
          <div style="display: flex">
            <el-select v-model="siteId" @change="getColumnTree">
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in siteIds"
                :key="index"
              ></el-option>
            </el-select>
            <el-input
              placeholder="搜索栏目名称"
              v-model="columnName"
              class="input-with-select"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="onSearch"
              ></el-button>
            </el-input>
          </div>

          <a-tree
            checkable
            v-model="selectedKeys"
            :selected-keys="selectedKeys"
            :tree-data="treeData"
            :check-strictly="true"
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            @check="onSelect"
            @select="treeNodeSelect"
            @expand="onExpand"
          />
        </div>
        <div class="org-right">
          <div class="select-number">
            <div class="number">已选{{ result.length }}个栏目</div>
            <a @click="clear" class="number">清空</a>
          </div>
          <div class="one-box">
            <div v-for="(item, index) in result" class="one" :key="index">
              <div class="name">{{ item.columnName }}</div>
              <i
                @click="deleteFn(index, item.id)"
                class="ri-close-fill close"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="btn">
        <a-button @click="close">取消</a-button>
        <a-button @click="submitOne" style="margin-left: 14px" type="primary"
          >确定</a-button
        >
      </div>
    </a-spin>
  </el-dialog>
</template>
<script>
import { set } from "vue";
import { getSiteByUserId } from "./manuscripts.js";
import { columnTree } from "./column.js";
export default {
  props: {
    isColumn: {
      type: Boolean,
      default: false,
    },
    isCaoSong: {
      type: Boolean,
      default: false,
    },
    columnIds: {
      type: Array,
      default: () => {
        return [];
      },
    },
    columnData:{
       type: Array,
        default: () => {
          return [];
        },
    },
    isEidt: {
      type: Boolean,
      default: false,
    },
    itemSiteIds: {
      type: Array,
      default: () => {
        return [];
      },
    },
    title: {
      type: String,
      default: "添加栏目",
    },
  },
  data() {
    return {
      treeData: [],
      columnName: "",
      selectedKeys: [],
      result: [],
      siteIds: [],
      oldKes: [],
      aTreeShow: false,
      oldData: [],
      siteId: Number(sessionStorage.getItem("siteId")),
      needBackShow: true, //用于编辑时回显判断
      arrayData: [],
      oldChangeData: [],
      expandedKeys: [],
      autoExpandParent: true,
      oldThreeData:[],

    };
  },
  watch: {
    arrayData() {
      if (this.arrayData.length == this.itemSiteIds.length) {
        let _this = this;
        let array = [];
        let arrayTwo = [];
        for (let index = 0; index < this.arrayData.length; index++) {
          const element = this.arrayData[index];
          let oneData = this.find(element, this.selectedKeys, []);
          array.push(...oneData);
        }
        for (let index = 0; index < this.arrayData.length; index++) {
          const element = this.arrayData[index];
          for (let indexTwo = 0; indexTwo < array.length; indexTwo++) {
            const elementTwo = array[indexTwo];
            let res = this.setColumnName(
              element,
              (data) => data.id === elementTwo.id
            ); //所有父级名称
            if (res.length > 0) {
              elementTwo.columnName = res.join(">");
            }
          }
        }
        _this.result = array;
      }
    },
    columnName(val) {
      this.onSearch();
    },
  },
  mounted() {
    if (this.columnData && this.columnData.length > 0) {
      let array = [];
      for (let index = 0; index < this.columnData.length; index++) {
        const element = this.columnData[index];
        if(element.columnId){
          array.push(element.columnId)
        }else{
           array.push(element.id)
        }
        
      }
      this.selectedKeys = JSON.parse(JSON.stringify(array));
      this.result = this.columnData;
    }
    this.needBackShow = this.isEidt;
    this.getSiteList();
    this.getColumnTree();
  },
  methods: {
    close() {
      this.$emit("colseChooseColumn");
       
    },
    submitOne() {
      this.oldData = JSON.parse(JSON.stringify(this.result));
      this.oldKes = JSON.parse(JSON.stringify(this.selectedKeys));
      this.$emit("setColumnIds", {
        columnIds: this.oldKes,
        columnData: this.oldData,
      });
    },
    deleteFn(index, key) {
      this.selectedKeys.splice(this.selectedKeys.indexOf(key), 1);
      this.result.splice(index, 1);
      this.selectedKeys = JSON.parse(JSON.stringify(this.selectedKeys));
    },
    deleteResult(index) {
      this.result.splice(index, 1);
    },
    treeNodeSelect(selectedKeys, e) {
      const toArray = (list) => Array.from(list || []);
      const node = e.nativeEvent.path.find((item) => {
        return (
          toArray(item.classList).findIndex(
            (className) => className == "ant-tree-treenode-switcher-close"
          ) != -1
        );
      });
      // 获取checkbox
      const checkbox = toArray(node.childNodes).find((item) => {
        return (
          toArray(item.classList).findIndex(
            (className) => className == "ant-tree-checkbox"
          ) != -1
        );
      });
      // 模拟点击
      checkbox && checkbox.click();
    },
    onSelect(checkedKeys) {
      this.selectedKeys = checkedKeys.checked;
       let result = JSON.parse(
        JSON.stringify(this.find(this.listData, this.selectedKeys, []))
      );
     result.map((item) => {
        let res = this.setColumnName(
          this.listData,
          (data) => data.id === item.id
        ); //所有父级名称
        item.columnName = res.join(">");
      });
      // this.oldChangeData = this.oldChangeData.filter((item) => {
      //   return item.siteId != this.siteId;
      // });
      result = [...result,...this.result]
      let arrayRest = [];
      for (let index = 0; index < result.length; index++) {
        const element = result[index];
        if( this.selectedKeys.indexOf(element.id) != -1){
            arrayRest.push(element)
        }
      }
      this.result = JSON.parse(JSON.stringify(this.removeDuplicateObj(arrayRest)));
      // this.result = [...this.oldChangeData, ...this.result];
     
    },
    removeDuplicateObj(arr) {
      let obj = {};
      arr = arr.reduce((newArr, next) => {
        obj[next.id] ? "" : (obj[next.id] = true && newArr.push(next));
        return newArr;
      }, []);
      return arr;
    },
    setColumnName(tree, func, res = []) {
      const _this = this;
      if (!tree) return;
      for (const data of tree) {
        res.push(data.columnName);
        if (func(data)) return res;
        if (data.children) {
          const findChildren = _this.setColumnName(data.children, func, res);
          if (findChildren.length) return findChildren;
        }
        res.pop();
      }
      return [];
    },
    clear() {
      this.result = [];
      this.selectedKeys = [];
    },
    find(arr, keys, selectArr) {
      arr.forEach((element) => {
        if (element.children) {
          if (keys.indexOf(element.id) != -1) {
            selectArr.push(element);
          }
          this.find(element.children, keys, selectArr);
        } else {
          if (keys.indexOf(element.id) != -1) {
            selectArr.push(element);
          }
        }
      });
      return selectArr;
    },
    getSiteList() {
      const _this = this;
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      getSiteByUserId({
        ids: userInfo.id,
        siteIds: userInfo.station,
        organizationIds: JSON.parse(sessionStorage.getItem("userInfo"))
          .organizationId,
        superManagement: userInfo.superManagement,
      }).then((res) => {
        if (res.code == 0) {
          _this.siteIds = res.data;
        }
      });
    },
    disFn(data) {
      for (let index = 0; index < data.length; index++) {
        if (data[index].children) {
          data[index].disabled = true;
          this.disFn(data[index].children);
        }
      }
      return data;
    },
    allData(element) {
      columnTree({
        siteId: element,
        orgIds: JSON.parse(sessionStorage.getItem("userInfo")).organizationId,
        columnName: "",
      }).then((res) => {
        if (res.code == 0) {
          this.arrayData.push(res.data);
        }
      });
    },
    getColumnTree() {
      this.aTreeShow = true;
      const _this = this;
      //this.oldChangeData = this.result;
      columnTree({
        columnName: _this.columnName,
        siteId: _this.siteId,
        orgIds: JSON.parse(sessionStorage.getItem("userInfo")).organizationId,
      }).then((res) => {
        if (res.code == 0) {
          _this.treeData = res.data;
          let options = JSON.stringify(res.data)
            .replace(/columnName/g, "title")
            .replace(/id/g, "key");
          _this.treeData = JSON.parse(JSON.stringify(JSON.parse(options)));
          _this.treeData = this.disFn(_this.treeData);
          _this.oldThreeData = _this.treeData;
          _this.expandedKeys = [this.treeData[0].key];

          _this.listData = res.data;
          if (_this.needBackShow) {
            //编辑稿件第一次进来
           if(this.itemSiteIds){
              for (let index = 0; index < this.itemSiteIds.length; index++) {
              const element = this.itemSiteIds[index];
              this.allData(element);
            }
           }
            _this.needBackShow = false;
            //     console.log(this.arrayData.length,'wc')
            //    for (let index = 0; index < this.arrayData.length; index++) {
            //         const element = this.arrayData[index];
            //         console.log(element,'adsa');
            //         let oneData =  this.find(element, this.selectedKeys, []);
            //         console.log(oneData,'sssssssssssssss');
            //         _this.result.push(...oneData);
            //    }

            //     console.log(_this.result,'不得行');
            //     _this.needBackShow = false
            //     _this.result.map(item=>{
            //         let res = this.setColumnName(this.listData,data=>data.id===item.id)//所有父级名称
            //         item.columnName = res.join('>')
            //     })
          }
          this.aTreeShow = false;
        }
      });
    },
    onSearch() {
      if (this.columnName === "") {
        this.treeData = this.oldThreeData;
        return;
      }
      let newData = JSON.parse(JSON.stringify(this.treeData));
      this.treeData = this.filterTree(newData, this.columnName);
      this.autoExpandParent = true;
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    filterTree(arr, keyword, first = true) {
      if (first) {
        //首次传入深度克隆数据防止修改源数据
        arr = JSON.parse(JSON.stringify(arr));
      }
      let emptyArr = [];
      for (let item of arr) {
        if (item.title.includes(keyword)) {
          // if (item.children &&Array.isArray(item.children)&& item.children.length > 0) {
          //     item.children = this.filterTree(item.children, keyword,false);
          // }
          emptyArr.push(item);
          this.expandedKeys.push(item.key)
        } else if (
          item.children &&
          Array.isArray(item.children) &&
          item.children.length > 0
        ) {
          item.children = this.filterTree(item.children, keyword, false);
          if (item.children.length) {
            emptyArr.push(item);
             this.expandedKeys.push(item.key)
          }
        }
      }
      return emptyArr;
    },
  },
};
</script>
<style lang="less" scoped>
.org-box {
  height: 400px;
  border-radius: 4px;
  border: solid 1px #e0e3e9;
  display: flex;
  .org-left {
    border-right: solid 1px #e0e3e9;
    flex: 1;
    height: 100%;
    padding: 20px;
    padding-bottom: 0px;
    overflow-y: auto;
    /deep/.el-input__inner {
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    /deep/.el-input-group--append .el-input__inner,
    .el-input-group__prepend {
      border-radius: 0;
    }
    /deep/ .ant-tree {
      height: 337px;
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
      overflow-x: hidden;
      overflow-y: auto;
    }
    ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  }
  .org-right {
    flex: 1;
    height: 100%;
    .one-box {
      overflow-y: auto;
      margin-top: 10px;
      height: 340px;
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
      overflow-x: hidden;
      overflow-y: auto;
    }
    ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .select-number {
      display: flex;
      justify-content: space-between;
      padding-left: 12px;
      padding-right: 12px;
      padding-top: 24px;
      .number {
        font-weight: 500;
      }
    }
    .one {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #1890ff;
      background: #ecf5ff;
      margin: 10px 20px;
      border-radius: 5px;
      padding: 0 10px;
      .name {
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 330px;
      }
      .icon-close:before {
        color: #1890ff;
      }
    }
    .one:first-child {
      margin-top: 0px;
    }
  }
}
.btn {
  margin-top: 24px;
  text-align: right;
}
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 9999;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
/deep/ .icon-close:before {
  position: relative;
  cursor: pointer;
  width: 12px;
  height: 12px;
  z-index: 1;
}
/deep/ .el-dialog__body {
  padding-top: 10px;
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
.close {
  font-size: 18px;
  color: #303133;
  cursor: pointer;
}
@media screen and (max-width: 720px) {
  .org-box {
    height: 65vh;
    display: block;
  }
  .org-box .org-left {
    height: auto;
    .ant-tree {
      height: 25vh;
    }
  }
  .org-box .org-right {
    height: auto;
    .one-box {
      height: 20vh;
      overflow: auto;
    }
  }
  .org-box .org-left {
    border-right: none;
  }
}
</style>